import React, { useState, useEffect } from 'react';
import './WelcomeModal.css';

const WelcomeModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has seen the welcome message
    const hasSeenWelcome = localStorage.getItem('hasSeenWelcome');
    if (!hasSeenWelcome) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem('hasSeenWelcome', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="welcome-modal-overlay">
      <div className="welcome-modal">
        <div className="welcome-modal-header">
          <div className="welcome-icon">🎨</div>
          <h2>Welcome to Caigoy Creations!</h2>
        </div>
        
        <div className="welcome-modal-body">
          <p className="welcome-message">
            Thank you for visiting! This is now a <strong>design demo</strong> site.
          </p>
          <p className="welcome-notice">
            🛍️ <strong>Please note:</strong> We are no longer accepting new orders or processing purchases through this site.
          </p>
          <p className="welcome-explore">
            However, you're welcome to explore our photo editing interface and try out the design tools! 
            Feel free to create custom designs and download them for your own reference.
          </p>
        </div>

        <div className="welcome-modal-footer">
          <button className="welcome-close-button" onClick={handleClose}>
            Got it, let me explore! 🚀
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;

